import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

import { CLASS_NAMES } from "./constants/classNames";

const { AREA_COLLAPSE } = CLASS_NAMES;

export const rootStyle = css`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 16px;

  ${MEDIA_QUERY_FOR_PC} {
    font-size: 16px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    font-size: 12px;
  }
`;

export const arrowIconWrapperStyle = css`
  color: #1e1e1e;
  display: block;

  & svg {
    ${MEDIA_QUERY_FOR_PC} {
      height: 8px;
      width: 12px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      height: 6px;
      width: 10px;
    }
  }
`;

export const downArrowIconWrapperStyle = css`
  transform: rotateZ(180deg);
  ${arrowIconWrapperStyle};
`;

export const rootTitleStyle = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-weight: 700;
  margin-right: 8px;
  text-align: left;
  width: 100%;
`;

const areaInner = css`
  ${MEDIA_QUERY_FOR_PC} {
    padding-left: 8px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-left: 6px;
  }
`;

export const areaOtherStyle = css`
  display: inline-block;
  ${areaInner};
`;

export const areaStyle = css`
  & + & {
    ${MEDIA_QUERY_FOR_PC} {
      margin-top: 16px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      margin-top: 12px;
    }
  }

  & .${AREA_COLLAPSE} {
    header {
      border-bottom: 1px solid #d9d9d9;
      ${areaInner};

      ${MEDIA_QUERY_FOR_PC} {
        padding-block: 8px;
      }

      ${MEDIA_QUERY_FOR_SP} {
        padding-block: 6px;
      }
    }

    div[id$="-panel"] {
      ${MEDIA_QUERY_FOR_PC} {
        margin-block: 8px;
        padding-inline: 24px;
      }

      ${MEDIA_QUERY_FOR_SP} {
        margin-block: 6px;
        padding-inline: 18px;
      }
    }
  }
`;

export const minusIconWrapperStyle = css`
  & svg {
    height: 2px;

    ${MEDIA_QUERY_FOR_PC} {
      width: 12px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      width: 9px;
    }
  }
`;

export const plusIconWrapperStyle = css`
  & svg {
    ${MEDIA_QUERY_FOR_PC} {
      height: 12px;
      width: 12px;
    }

    ${MEDIA_QUERY_FOR_SP} {
      height: 9px;
      width: 9px;
    }
  }
`;

export const prefecturesStyle = css`
  display: grid;
  padding-block: 32px 28px;
  row-gap: 32px;

  ${MEDIA_QUERY_FOR_PC} {
    grid-template-columns: repeat(5, 1fr);
    width: 90%;
  }

  ${MEDIA_QUERY_FOR_SP} {
    grid-template-columns: repeat(2, 1fr);
    width: 74%;
  }
`;

export const prefectureStyle = css`
  ${MEDIA_QUERY_FOR_SP} {
    display: inline-block;
    width: 112px;
  }
`;
